import { Component, OnInit } from '@angular/core';
import { FinDokumentStavkaView } from './fin-dokument-stavka-view';
import { BaseDetailListSum, UserService } from 'yt-ng-framework';
import { DecimalPipe } from '@angular/common';

@Component({
  selector: 'yt-fin-dokument-sum',
  templateUrl: './fin-dokument-sum.component.html'
})
export class FinDokumentSumComponent extends BaseDetailListSum<FinDokumentStavkaView> {

  constructor(
    protected decimalPipe: DecimalPipe,
    protected userService: UserService
){
    super();
}

private _ukupnoDuguje: number = 0;
private _ukupnoPotrazuje: number = 0;
private _ukupnoDDuguje: number = 0;
private _ukupnoDPotrazuje: number = 0;

ukupnoDuguje: string;
ukupnoPotrazuje: string;
ukupnoDDuguje: string;
ukupnoDPotrazuje: string;

calculate(){
  super.calculate();

  this._ukupnoDuguje=0;
  this._ukupnoPotrazuje=0;
  this._ukupnoDDuguje=0;
  this._ukupnoDPotrazuje=0;

  if(this.Items && this.Items.size > 0){
    this.Items.forEach((item: FinDokumentStavkaView) => {
      this._ukupnoDuguje += item.Duguje;
      this._ukupnoPotrazuje += item.Potrazuje;
      this._ukupnoDDuguje += item.DDuguje;
      this._ukupnoDPotrazuje += item.DPotrazuje;
    })

  }

  this.ukupnoDuguje = this.decimalPipe.transform(this._ukupnoDuguje, this.userService.GetNumberFormat(), this.userService.GetLocaleString());
  this.ukupnoPotrazuje = this.decimalPipe.transform(this._ukupnoPotrazuje, this.userService.GetNumberFormat(), this.userService.GetLocaleString());
  this.ukupnoDDuguje = this.decimalPipe.transform(this._ukupnoDDuguje, this.userService.GetNumberFormat(), this.userService.GetLocaleString());
  this.ukupnoDPotrazuje = this.decimalPipe.transform(this._ukupnoDPotrazuje, this.userService.GetNumberFormat(), this.userService.GetLocaleString());


}

}
